import getRemBase from './getRemBase';

const setHeaderHeight = () => {
	const header = document.querySelector('.main-header');
	const adminBar = document.getElementById('wpadminbar');

	const headerHeight = header ? header.offsetHeight : 0;
	const adminBarHeight = adminBar ? adminBar.offsetHeight : 0;

	document.body.style.setProperty(
		'--header-height',
		`${headerHeight / getRemBase()}rem`
	);

	if ('' === document.body.style.getPropertyValue('--alert-height')) {
		document.body.style.setProperty('--alert-height', `0rem`);
	}

	document.body.style.setProperty(
		'--admin-bar-height',
		`${adminBarHeight / getRemBase()}rem`
	);
};

export default setHeaderHeight;
